export default "__VITE_ASSET__w9Hn9kuh__"